const getDatetimeFromStringISO = (stringISO: string): string => {
  const d = new Date(stringISO);
  const date = d.toLocaleDateString('pt-BR');
  const hour = d.toLocaleTimeString('pt-BR');

  return `${date} às ${hour}`;
};

const getCurrentMillis = (): number => new Date().getTime();

export default { getDatetimeFromStringISO, getCurrentMillis };
